var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('drawing-canvas',{ref:"canvas",staticClass:"drawing-canvas",on:{"dragStart":_vm.dragStart,"dragEnd":_vm.dragEnd,"dragging":_vm.dragging}})
}
var staticRenderFns = []

export { render, staticRenderFns }